import { AppRoutes } from "../../routes/routes";
import { DatePickerError, DatePickerRange } from "./audit-log-types";
export class AuditLogViewModel {
    store;
    service;
    name = this.constructor.name;
    _datePickerRange = DatePickerRange.lastWeek;
    _dateStart = this.weekBackDate;
    _dateEnd = this.todayDate;
    // min and max are values that we enable the user to select in UI
    _dateMin = this.yearBackDate;
    _dateMax = this.todayDate;
    constructor(store, service) {
        this.store = store;
        this.service = service;
    }
    // Getter props
    get auditLog() {
        return this.store.auditLog;
    }
    get selectedAuditEntry() {
        return this.store.selectedAuditEntry;
    }
    get datePickerRange() {
        return this._datePickerRange;
    }
    get dateStart() {
        return this._dateStart;
    }
    get dateEnd() {
        return this._dateEnd;
    }
    get dateMin() {
        return this._dateMin;
    }
    get dateMax() {
        return this._dateMax;
    }
    get yearBackDate() {
        const yearBack = new Date();
        yearBack.setFullYear(yearBack.getFullYear() - 1);
        yearBack.setHours(0, 0, 0, 0);
        return yearBack;
    }
    get monthBackDate() {
        const monthBack = new Date();
        // allow to select 1.1.2025 - 1.2.2025 (included)
        monthBack.setDate(monthBack.getDate() - 32);
        monthBack.setHours(0, 0, 0, 0);
        return monthBack;
    }
    get weekBackDate() {
        const weekBack = new Date();
        weekBack.setDate(weekBack.getDate() - 7);
        weekBack.setHours(0, 0, 0, 0);
        return weekBack;
    }
    get todayDate() {
        return new Date();
    }
    // Actions
    setSelectedDate(pickerRange, strDateStart, strDateEnd) {
        this._datePickerRange = pickerRange;
        switch (pickerRange) {
            case DatePickerRange.lastWeek:
                this._dateStart = this.weekBackDate;
                this._dateEnd = this.todayDate;
                return null;
            case DatePickerRange.lastMonth:
                this._dateStart = this.monthBackDate;
                this._dateEnd = this.todayDate;
                return null;
            case DatePickerRange.customRange:
                return this.handleSetCustomRangeDates(strDateStart, strDateEnd);
        }
    }
    setSelectedAuditEntry(entry) {
        this.store.setSelectedAuditEntry(entry);
    }
    // Service calls
    async getAuditLog(userId, logOnSuccess = false) {
        await this.service.getAuditLog(userId, this.dateStart, this.dateEnd, logOnSuccess);
    }
    notifyLocationChanged(route, params) {
        // AuditLog List
        if (route === AppRoutes.AuditLog && params?.userId) {
            // if there are no data, we want to do init call on route change
            if (this.store.auditLog.length === 0) {
                void this.getAuditLog(params.userId);
            }
        }
        // AuditLog Detail
    }
    handleSetCustomRangeDates(strDateStart, strDateEnd) {
        if (!strDateStart || !strDateEnd) {
            return DatePickerError.MissingDate;
        }
        const dateStart = new Date(strDateStart);
        dateStart.setHours(0, 0, 0, 0);
        const dateEnd = new Date(strDateEnd);
        dateEnd.setHours(23, 59, 59, 999);
        if (dateEnd < dateStart) {
            return DatePickerError.SwitchedStartEnd;
        }
        if (moreThanMonthApart(dateStart, dateEnd)) {
            return DatePickerError.MaxMonthRange;
        }
        // validations ok, we can set dates and return
        this._dateStart = dateStart;
        this._dateEnd = dateEnd;
        return null;
    }
}
function moreThanMonthApart(start, end) {
    const diffInTime = end.getTime() - start.getTime();
    const diffInDays = diffInTime / (1_000 * 3_600 * 24);
    // we allow 32 days to cover date ranges like 1.1.2025 - 1.2.2025
    return Math.abs(diffInDays) > 32;
}
export function dateToStr(date) {
    return date.toISOString().split("T")[0];
}
